import { Button } from '@/common/components/Button/Button';
import { Icon } from '@/common/components/Icons/Icon';
import { Stack } from '@/common/components/Stack/Stack';

export const PlaygroundButtons = () => {
  return (
    <Stack gap="md">
      <Button>Primary Button</Button>
      <Button variant="secondary" icon={<Icon icon="language" />}>
        Secondary Button
      </Button>
      <Button variant="tertiary">Tertiary Button</Button>
      <Button variant="info">Info Button</Button>
      <Button loading>Loading Button</Button>
    </Stack>
  );
};
